import { useIonRouter } from "@ionic/react";
import { MessageSearch as SbMessageSearch } from "@wearesweet/sendbird-uikit-react";
import React from "react";

export const MessageSearch = (props: any) => {
  const router = useIonRouter();
  const channelUrl = props.match.params.channelUrl;

  //useNavigateOnBan()
  return (
    <div style={{ height: "100vh" }}>
      <SbMessageSearch
        channelUrl={channelUrl as string}
        onCloseClick={() => {
          router.push(`/chat/channels/${channelUrl}`);
        }}
        onResultClick={(message) => {
          router.push(`/chat/channels/${channelUrl}?messageId=${message?.messageId}&createdAt=${message?.createdAt}`);
        }}
      />
    </div>
  );
};
